import React from 'react'
import BlogComp1 from '../components/BlogComp1'
import BlogComp2 from '../components/BlogComp2'

function Blog() {
  return (
    <div>
      <BlogComp1/>
      <BlogComp2/>
    </div>
  )
}

export default Blog